export default {
  data() {
    return {
      data: {},
      modalVisible: false,
    }
  },

  created() {

  },

  methods: {
    init(id) {
      this.reset()

      this.id = id
      this.modalVisible = true
      if (this.id) {
        this.query()
      }
    },

    reset() {
      this.data = {}
      this.id = null
    },
    query() {
      this.loading = true
      this.$request.licenseException(this.id).then(resp => {
        resp.data = this.$utils.conv(resp.data,{eventTime:'datetime',state:'licenseExceptionState'})
        this.data = resp.data || {}
        this.loading = false
      })
    }
  },
  render() {
    const data = this.data || {}

    return <sl-side-panel v-model={this.modalVisible} loading={this.loading} mask-closable={false} title="基本信息" on-close={this.reset}>
        <sl-detail-list col={1} labelAlign="right" labelWidth="100px" style="padding:12px;">
          <sl-detail-list-item title="姓名">{data.userName}</sl-detail-list-item>
          <sl-detail-list-item title="手机号">{data.userPhone}</sl-detail-list-item>
          <sl-detail-list-item title="身份证">{data.userIdcard}</sl-detail-list-item>

          <sl-detail-list-item title="快递品牌" content={data.brandName} />
          <sl-detail-list-item title="所属企业" content={data.companyName} />
          <sl-detail-list-item title="登记人" content={data.creatorName} />
          <sl-detail-list-item title="登记单位" content={data.organizationName} />
          <sl-detail-list-item title="登记时间" content={data.eventTimeText} />
          <sl-detail-list-item title="状态" content={data.stateText} />
          <sl-detail-list-item title="备注" content={data.eventDesc} />
          <sl-detail-list-item title="照片">
            <sl-carousel images={data.eventImages ? data.eventImages.split(';') : []} /> 
          </sl-detail-list-item>

        </sl-detail-list>
        
    </sl-side-panel>
  }
}
